// extracted by mini-css-extract-plugin
export default {"dataList":"ReportMainInfo_dataList__-0VHd"};